
import axios from 'axios';


function useUser() {
    const baseUrl = process.env.REACT_APP_API_HOST;

    async function createUser(user) {
        const endpoint = '/api/User/Create';
        const api = axios.create({ baseURL: baseUrl + endpoint });
        let isCreated = null;
        await api.post('',
            user,
            {
                headers: {
                    //'Authorization': `Bearer ${token}`
                }
            })
            .then(response => {
                isCreated = true;
            })
            .catch(error => {
                isCreated = false;
            });
        return isCreated;
    }

    return {
        createUser
    }
}

export default useUser;